// extracted by mini-css-extract-plugin
export default {"primary-item":"yugu","primary-item-menu":"GFZM","active":"lptX","secondary-item":"zDNe","mobile-link":"jtp5"};